import cookie from 'js-cookie';
export function getCookie(cookieName) {
    return cookie.get(cookieName);
}
export function setCookie(_cookie) {
    return cookie.set.apply(cookie, _cookie);
}
export function dateFormat(time) {
    if ('-'.indexOf(time) > -1) {
        return time;
    }
    var date = new Date(time);
    var resData = date.getFullYear() + '-' + numFormat((date.getMonth() + 1)) + '-' + numFormat(date.getDate());
    return resData;
}
function numFormat(num) {
    return num < 10 ? '0' + num : num;
}
export function getBrowserInfo() {
    var ua = navigator.userAgent;
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var htmlWidth = document.body.clientWidth;
    var htmlHeight = document.body.clientHeight;
    return {
        ua: ua,
        screenWidth: screenWidth,
        screenHeight: screenHeight,
        htmlWidth: htmlWidth,
        htmlHeight: htmlHeight
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/base.ts
// module id = null
// module chunks = 